export default {
  //заполнить список типов партнеров
  loadPartnerTypes(state, data){
    state.items=data;
  },
}
